export interface StarProps {
  star: number
  rate: number
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const useStar = (props: StarProps) => {
  return {
    ...props,
  }
}
